<template>
	<div class="mainContainer">
		<header class="">
			<a href="#" class="logo">{{headerName}} </a>
			<a href="#" @click.prevent="toggleClass" class="menuBtn">
				<span class="lines"></span>
			</a>
			<nav class="mainMenu">
				<ul>
          <li>
            <img :src="require('../assets/img/logo-levantek-350.png')" >
          </li>
					<li>
            <ion-item lines="none">
              <ion-icon style="margin-right:10px;" name="home" slot="start"></ion-icon>
              <ion-label @click="goHome()" > 
                Inicio 
              </ion-label>
            </ion-item>
					</li>

					<li v-if="userTypeName == 'OP' " >
            <ion-item lines="none" >
              <ion-icon style="margin-right:10px;" :src="require('../assets/svg/alert-circle-outline.svg')" slot="start"></ion-icon>
              <ion-label @click="goToPendiente('ADMS')" > 
                Solicitues en ADMS 
              </ion-label>
            </ion-item>
					</li>

					<li v-if="userTypeName == 'ADMS' ">
            <ion-item lines="none" >
              <ion-icon style="margin-right:10px;" :src="require('../assets/svg/alert-circle-outline.svg')" slot="start"></ion-icon>
              <ion-label @click="goToPendiente('OP')" > 
                Solicitues en OP 
              </ion-label>
            </ion-item>
					</li>

					<li>
            <ion-item lines="none" >
              <ion-icon style="margin-right:10px;" :src="require('../assets/svg/checkmark-done-outline.svg')"></ion-icon>
              <ion-label @click="goFinalizadas()">
                Solicitues Finalizadas 
              </ion-label>
            </ion-item>
					</li>
					<li>
            <ion-item lines="none" >
              <ion-icon style="margin-right:10px;" :src="require('../assets/svg/lock-closed-outline.svg')" slot="start"></ion-icon>
              <ion-label @click="logOut()"> 
                Cerrar sesión 
              </ion-label>
            </ion-item>
					</li>
				</ul>
			</nav>
		</header>
		<div class="container">
		</div>
		<footer>
		</footer>
	</div>
<!-- 
    <ul id="slide-out" class="sidenav">
      <li>
        <div class="user-view">
          <div class="background">
            
            <img :src="require('../assets/img/logo-levantek-350.png')" >
          </div>
        <a href="#name"><span class="white-text name">John Doe</span></a>
        <a href="#email"><span class="white-text email">jdandturk@gmail.com</span></a>
      </div></li>
      <li><a href="#!"><i class="material-icons">cloud</i>First Link With Icon</a></li>
      <li><a href="#!">Second Link</a></li>
      <li><div class="divider"></div></li>
      <li><a class="subheader">Subheader</a></li>
      <li><a class="waves-effect" href="#!">Third Link With Waves</a></li>
    </ul> -->
  <!-- </div> -->
</template>
<style scoped>
  @font-face {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 400;
    src: local('Lato Regular'), local('Lato-Regular'), url(https://fonts.gstatic.com/s/lato/v16/S6uyw4BMUTPHjx4wWw.ttf) format('truetype');
  }
  .mainContainer{ margin-bottom: 10px;}
  * {
    margin: 0;
    padding: 0;
  }
  *,
  *:after,
  *:before {
    box-sizing: border-box;
  }
  .mainMenu ol,
  .mainMenu ul {
    list-style: none;
  }
  .mainMenu a {
    color: #000;
    text-decoration: none;
  }

  .mobile {
    background-color: #19b698;
    border: 0 solid #333;
    border-width: 50px 15px;
    border-radius: 12px;
    box-shadow: 5px 5px 0 rgba(0, 0, 0, 0.6);
    margin: 20px auto;
    max-width: 300px;
    height: 560px;
    overflow: hidden;
    position: relative;
  }
  .mainContainer header {
    background-color: #fff;
    background-color: rgba(255, 255, 255, 0);
    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.2);
    height: 50px;
  }
  .logo {
    color: #000;
    font-size: 20px;
    line-height: 50px;
    padding: 0 0 0 20px;
    text-transform: capitalize;
  }
  /* menu button */
  .menuBtn {
    height: 30px;
    width: 30px;
    position: absolute;
    right: 20px;
    top: 10px;
    z-index: 101;
  }
  .menuBtn > span {
    background-color: #585858;
    border-radius: 1px;
    height: 2px;
    width: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    margin: -1px 0 0 -15px;
    -webkit-transition: height 100ms;
    transition: height 100ms;
  }
  .menuBtn > span:after,
  .menuBtn > span:before {
    content: '';
    background-color: #585858;
    border-radius: 1px;
    height: 2px;
    width: 100%;
    position: absolute;
    left: 50%;
    margin-left: -15px;
    -webkit-transition: all 200ms;
    transition: all 200ms;
  }
  .menuBtn > span:after {
    top: -7px;
  }
  .menuBtn > span:before {
    bottom: -7px;
  }
  .menuBtn.act > span {
    height: 0;
  }
  .menuBtn.act > span:after,
  .menuBtn.act > span:before {
    background-color: #008877;
    top: 1px;
  }
  .menuBtn.act > span:after {
    -webkit-transform: rotate(45deg);
            transform: rotate(45deg);
  }
  .menuBtn.act > span:before {
    -webkit-transform: rotate(-45deg);
            transform: rotate(-45deg);
  }
  /* main menu block */
  .mainMenu {
    font-family: Lato;
    background-color: #fff;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 100;
    height: 100%;
    width: 100%;
    display: table;
    text-align: center;
    opacity: 0;
    -webkit-transition: all 500ms cubic-bezier(0.68, -0.55, 0.265, 1.55);
    transition: all 500ms cubic-bezier(0.68, -0.55, 0.265, 1.55);
    -webkit-transform: scale(0);
            transform: scale(0);
  }
  .mainMenu.act {
    opacity: 1;
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  .mainMenu.act ul li {
    opacity: 1;
    -webkit-transform: translateX(0);
            transform: translateX(0);
  }
  .mainMenu ul {
    display: table-cell;
    vertical-align: middle;
  }
  .mainMenu li {
    width: 100%;
    padding: 8px 0;
    -webkit-transition: all 400ms 510ms;
    transition: all 400ms 510ms;
    opacity: 0;
  }
  .mainMenu li:nth-child(odd) {
    -webkit-transform: translateX(30%);
            transform: translateX(30%);
  }
  .mainMenu li:nth-child(even) {
    -webkit-transform: translateX(-30%);
            transform: translateX(-30%);
  }
  .mainMenu li:last-child {
    -webkit-transform: none;
            transform: none;
  }
  .mainMenu a {
    color: #0274be;
    display: inline-block;
    font-size: 18px;
    font-family: Lato;
    font-weight: 600;
  }
  .mainMenu a.suBtn {
    color: #000;
  }
  /* sign up button */
  .suBtn {
    background-color: #19b698;
    border-radius: 5px;
    padding: 10px 20px;
  }

/* //   .m{
//     &-20{
//       margin: 20px;
//     }
//   }
//   :host(.button-inner){justify-content: left;}
//   ion-button{
//     font-size: .8em;
//     & span{ justify-content: left !important; }
//     --background:transparent;
//     --background-actived:pink;

//     & button{ background-color: transparent !important; }
//     --background-focused: transparent;
//     --background-hover: transparent;
//     --color: #000;
//     --color-activated: #000;
//     --color-focused: #000;
//     border: none !important;
//     color:#000 !important;
//     --box-shadow: none;
//   }
//   button.button-native{
//     background-color: transparent !important;
//     border: none !important;
//     color:#000 !important;
//     box-shadow: none !important;
//   }
// .no-color button span{color:green($color: #000000);} */

</style>
<script>
import firebase from 'firebase/app';
import 'firebase/auth';
export default {
  name: "NavBarUsr",
  // props: ["items"]
  data() {
    return {
      EstamosEn:"ninguno"
    }
  },
  props:{

      userTypeName: { type:String, default:"nono"},
      headerName: { type:String, default:"Solicitudes"}
    }
  ,
  methods: {
    toggleClass() {
      // ar menu = document.querySelector('.menu') // Using a class instead, see note below.
      // menu.classList.toggle('hidden-phone')
      let $menu = document.querySelector('.menuBtn');
      let _subMenu = document.querySelector('.mainMenu')

      $menu.classList.toggle("act");
      
      // $(this).toggleClass('act');
      if( $menu.classList.contains('act') ) {
				_subMenu.classList.add('act');
			}
			else {
				_subMenu.classList.remove('act');
      }
      
    },
    goToPendiente(tipo){
      this.$router.replace('/pendiente/'+ tipo);
    },
    alerta() {
      alert("example . . .");
    },

    goHome() {
      this.$router.replace('/');
    },

    goFinalizadas() {
      this.$router.replace('/solicitudes-finalizadas');
    },
    logOut(){
      firebase.auth().signOut().then( ()=>{
        console.log("closed");
        window.location.href = "/";
      } );
    }
  },

};
</script>